import D1 from "../../components/ExcerciseTypes/Design/TypeIn";
import UI from "../../components/ExcerciseTypes/Design/UserInterface";

const json = {
  1: {
    // Exercise number
    unit: "Unit 1",
    id: "SB3-U1-P13-E1",
    audio: "img/FriendsPlus/Page13/Audio/audio-e1-p13.mp3",
    video: "",
    component: D1,
    exerciseKey: "img/FriendsPlus/Page13/E1/Key/answerKey.png",
    maxLength: 1,
    textAlign: 'center',
    // padding: 0,
    isAllowSubmit: false,
    questionImage: [
      // Row
      [
        // Column1
        { url: "img/FriendsPlus/Page13/E1/1.jpg" },
        {
          url: "img/FriendsPlus/Page13/E1/2.jpg",
          audioUrl: "img/FriendsPlus/Page13/Audio/tieude-e1-p13.mp3",
        },
        { url: "img/FriendsPlus/Page13/E1/3.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page13/E1/4.jpg" }],
      [
        // Column3
        { url: "img/FriendsPlus/Page13/E1/5.jpg" },
        { url: "img/FriendsPlus/Page13/E1/6.jpg", input: true, answer: "A" },
        { url: "img/FriendsPlus/Page13/E1/7.jpg" },
        { url: "img/FriendsPlus/Page13/E1/8.jpg", input: true, answer: "A" },
        { url: "img/FriendsPlus/Page13/E1/9.jpg" },
        { url: "img/FriendsPlus/Page13/E1/10.jpg", input: true, answer: "B" },
        { url: "img/FriendsPlus/Page13/E1/11.jpg" },
        { url: "img/FriendsPlus/Page13/E1/12.jpg", input: true, answer: "B" },
        { url: "img/FriendsPlus/Page13/E1/13.jpg" },
        { url: "img/FriendsPlus/Page13/E1/14.jpg", input: true, answer: "B" },
        { url: "img/FriendsPlus/Page13/E1/15.jpg" },
      ],
    ],
  },
  2: {
    // Exercise num
    unit: "Unit 1",
    id: "SB3-U1-P13-E2",
    audio: "",
    video: "",
    component: UI,
    question: [],
    questionImage: [
      [{ url: "img/FriendsPlus/Page13/E2/1.jpg" }],
      [{ url: "img/FriendsPlus/Page13/E2/2.jpg" }],
    ],
  },
  3: {
    // Exercise num
    unit: "Unit 1",
    id: "SB3-U1-P13-E3",
    audio: "",
    video: "",
    component: D1,
    typeInput: "center",
    // fontSize: 30,
    // inputHeight: "100%",
    //isAllowSubmit: false,
    // isLargeInput: true,
    maxLength: 1,
    isAllowSubmit: false,
    exerciseKey: "img/FriendsPlus/Page13/E3/Key/answerKey.png",
    questionImage: [
      [{ url: "img/FriendsPlus/Page13/E3/1.jpg" }],
      [
        // Column2
        { url: "img/FriendsPlus/Page13/E3/2.jpg" },
        { url: "img/FriendsPlus/Page13/E3/3.jpg", input: true, answer: "?" },
        { url: "img/FriendsPlus/Page13/E3/4.jpg" },
        { url: "img/FriendsPlus/Page13/E3/5.jpg", input: true, answer: "." },
        { url: "img/FriendsPlus/Page13/E3/6.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page13/E3/7.jpg" }],
      [
        // Column4
        { url: "img/FriendsPlus/Page13/E3/8.jpg" },
        { url: "img/FriendsPlus/Page13/E3/9.jpg", input: true, answer: "?" },
        { url: "img/FriendsPlus/Page13/E3/10.jpg" },
        { url: "img/FriendsPlus/Page13/E3/11.jpg", input: true, answer: "." },
        { url: "img/FriendsPlus/Page13/E3/12.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page13/E3/13.jpg" }],
      [
        // Column6
        { url: "img/FriendsPlus/Page13/E3/14.jpg" },
        { url: "img/FriendsPlus/Page13/E3/15.jpg", input: true, answer: "?" },
        { url: "img/FriendsPlus/Page13/E3/16.jpg" },
        { url: "img/FriendsPlus/Page13/E3/17.jpg", input: true, answer: "." },
        { url: "img/FriendsPlus/Page13/E3/18.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page13/E3/19.jpg" }],
      [{ url: "img/FriendsPlus/Page13/E3/20.jpg" }],
    ],
  },
  4: {
    // Exercise num
    unit: "Unit 1",
    id: "SB3-U1-P13-E4",
    audio: "",
    video: "",
    component: UI,
    question: [],
    questionImage: [
      [{ url: "img/FriendsPlus/Page13/E4/1.jpg" }],
      [{ url: "img/FriendsPlus/Page13/E4/2.jpg" }],
      [{ url: "img/FriendsPlus/Page13/E4/3.jpg" }],
      [{ url: "img/FriendsPlus/Page13/E4/4.jpg" }],
    ],
  },
};

export default json;
